<template>
	<div class="skyTextarea">
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
  		<el-form-item label="" prop="inputValue">
				<el-input
					:style="{ width: width }"
					v-bind="$attrs"
					:rows="3"
					:clearable="clearable"
					type="textarea"
					v-model="ruleForm.inputValue"
					@input="input"
					:disabled="filterOptions()"
					:placeholder="placeholder"
				>
				</el-input>
				<span class="len">{{ len }}/{{ maxlength }}</span>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
export default {
	name: 'skyTextarea',
	props: {
		placeholder: {
			type: String,
			default: ''
		},
		value: {
			type: String,
			default: ''
		},
		clearable: {
			type: Boolean,
			default: true
		},
		width: {
			type: String,
			default: '100%'
		},
		maxlength: {
			type: String,
			default: '255'
		},
		filterOptions: {
			type: Function,
			default: () => false
		}
	},
	data() {
		let validataLength = (rule, value, callback) => {
			function lengthOccurrences(txt) {
				let temp = 0;
				for (let i = 0; i < txt.length; i++) {
					if (/[^\x00-\xff]/.test(txt[i])) {
						temp += 2;
					} else {
						temp++;
					}
				}
				return temp;
			}
			
			this.len = lengthOccurrences(value);
			if ( this.len > this.maxlength) {
				callback(new Error(`字符限制为${this.maxlength}个字符`));
			} else {
				callback();
			}
		};
		return {
			ruleForm: {inputValue: ''},
			rules: {
				inputValue: [
					{ required: true, message: '内容不能为空', trigger: 'change' },
					{ validator: validataLength, trigger: 'change' },
				],
			},
			len: 0,
		};
	},
	mounted() {
		this.len = this.length(this.value);
	},
	methods: {
		input(val) {
			this.$emit('input', val);
			this.$emit('change', val);
		},
		length(txt) {
			let temp = 0;
			for (let i = 0; i < txt.length; i++) {
				if (/[^\x00-\xff]/.test(txt[i])) {
					temp += 2;
				} else {
					temp++;
				}
			}
			return temp;
		}
	},
	watch: {
		value: {
			handler(newValue) {
				this.ruleForm.inputValue = newValue;
			},
			immediate: true
		}
	}
};
</script>
<style lang="scss">
.skyTextarea {
	textarea,
	textarea::placeholder {
		font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial,
			sans-serif;
	}
	.len {
		display: inline-block;
		margin: 0 0 15px 5px;
	}
}
</style>
